import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'

InertiaProgress.init()
const pinia = createPinia()
createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - 株式会社エイアンドエフ | 世界のアウトドア用品を45年輸入販売` : '株式会社エイアンドエフ | 世界のアウトドア用品を45年輸入販売',
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(pinia)
      .mount(el)
  },
})
